var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-box"},_vm._l((_vm.titleArr),function(item,index){return _c('div',{key:index,class:{'end-route':index==_vm.titleArr.length-1}},[_vm._v(_vm._s(item+(index==_vm.titleArr.length-1?'':'>')))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }